import { useRoutes } from 'react-router-dom'

import { useScrollToTop } from 'hooks/router'

import { Links, TokenSubLinks } from 'constants/link'

import Home from './Home'
import Airdrop from './Airdrop'
import Approval from './Approval'

import { Faq } from './Faq'
import { Tutorial } from './Tutorial'

import { NotFound } from './NotFound'

function Router() {
  useScrollToTop()

  return useRoutes([
    {
      path: Links.HOME,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: Links.TOKEN,
          children: [
            {
              index: true,
              element: <Home />,
            },
            {
              path: TokenSubLinks.APPROVAL,
              element: <Approval />,
            },
            {
              path: TokenSubLinks.AIRDROP,
              element: <Airdrop />,
            },
            {
              path: TokenSubLinks.TUTORIAL,
              element: <Tutorial />,
            },
            {
              path: TokenSubLinks.FAQ,
              element: <Faq />,
            },
          ],
        },
      ],
    },
    { path: '*', element: <NotFound /> },
  ])
}

export default Router
